﻿import core from "./ts/core";
import components_ from "./ts/modules/components";
import context_ from "./ts/modules/context";
import utilities_ from "./ts/modules/utilities";
import lazzyLoader_ from "./ts/modules/lazzyLoader";
import debug_ from "./ts/modules/debug";

declare function require(module: string): unknown;
const components = require("./ts/modules/components") as typeof components_;
const context = require("./ts/modules/context") as typeof context_;
const utilities = require("./ts/modules/utilities") as typeof utilities_;
const lazzyLoader = require("./ts/modules/lazzyLoader") as typeof lazzyLoader_;
const debug = require("./ts/modules/debug") as typeof debug_;

(g => {
    const jsUtilities = require("./js/jsUtilities") as any;
    const jsClasses = require("./js/jsClasses") as any;

    //Modules principaux
    g.main = {
        core: core,
        context: context,
        utilities: utilities,
        components: components,
        lazzyLoader: lazzyLoader,
        //code non-migré en typescript 
        js: {
            classes: jsClasses,
            utilities: jsUtilities
        },
        debug: debug
    };

    //g.jQuery(document).ready(e => {
    //    g.currentContext.runOnDocumentReadyActions(e);
    //});

    // Native
    g.document.onreadystatechange = () => {
        if (document.readyState === "complete")
            g.currentContext.runOnDocumentReadyActions();
    }
})(window as any);
